import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./dialog.module.scss";
import * as DialogRU from "@radix-ui/react-dialog";
import { DialogCloseButton } from "./dialogCloseButton";
import classNames from "classnames";

export const Dialog = (
  props: Props = {
    opened: false,
    withCloseButton: true,
    withPortal: true,
    withOverlay: true,
    close: () => {},
    style: {},
  },
): ReactElement => {
  const PortalComponent = props.withPortal ? DialogRU.Portal : React.Fragment;

  return (
    <DialogRU.Root open={props.opened}>
      <PortalComponent>
        {props.withOverlay && (
          <DialogRU.Overlay
            className={styles.overlay}
            onClick={props.closeOnClickOutside ? props.close : undefined}
          />
        )}
        <DialogRU.Content
          className={classNames(styles.content, props.contentClassName)}
          style={props.style}
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          {props.withCloseButton && (
            <DialogRU.Close asChild onClick={props.close}>
              <DialogCloseButton />
            </DialogRU.Close>
          )}
          {props.children}
        </DialogRU.Content>
      </PortalComponent>
    </DialogRU.Root>
  );
};

export const DialogTitle = DialogRU.Title;
export const DialogDesc = DialogRU.Description;

interface Props extends PropsWithChildren {
  opened: boolean;
  close: () => void;
  withCloseButton?: boolean;
  withPortal?: boolean;
  withOverlay?: boolean;
  closeOnClickOutside?: boolean;
  contentClassName?: string;
  style?: React.CSSProperties;
}
